module.exports = __webpack_public_path__ + "static/media/portallogo-white.c661d320.png";